import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["color", "size"];
import React from 'react';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var IconMenuAch = function IconMenuAch(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === void 0 ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    size = _ref$size === void 0 ? 24 : _ref$size,
    otherProps = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/_jsxs("svg", _objectSpread(_objectSpread({
    xmlns: "http://www.w3.org/2000/svg",
    width: size,
    height: size,
    fill: color
  }, otherProps), {}, {
    viewBox: "0 0 40 40",
    children: [/*#__PURE__*/_jsx("path", {
      d: "M5.625 9.895a.84.84 0 000 1.381l6.785 4.697a.84.84 0 001.318-.69v-3.097H30.99c.275 0 .499.222.499.5v5.645a1.6 1.6 0 003.2 0v-5.645c0-2.043-1.654-3.7-3.699-3.7H13.728V5.889a.84.84 0 00-1.318-.69L5.625 9.894z"
    }), /*#__PURE__*/_jsx("path", {
      d: "M26.273 27.814v-3.096a.84.84 0 011.318-.691l6.784 4.697a.84.84 0 010 1.38l-6.784 4.698a.84.84 0 01-1.319-.69v-3.098H9.01a3.699 3.699 0 01-3.699-3.7V21.67a1.6 1.6 0 113.2 0v5.645c0 .278.224.5.499.5h17.263z"
    })]
  }));
};
export default IconMenuAch;